import React, { useEffect, useRef, useState } from "react";
import { Checkbox, DatePicker, Form, Input, Modal, Radio, Select, Spin } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { save } from "../../../../features/save/saveSlice"; 
import moment from "moment";
import dayjs from "dayjs";

const { TextArea } = Input;

const AddFiscalModal = ({ open, handleCancel, handleFetchData, prodd }) => {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const today = new Date();
  let dd = String(today.getDate()).padStart(2, 0);
  let mm = String(today.getMonth() + 1).padStart(2, 0);
  let yyyy = today.getFullYear() - 18;

  let minDate = `${yyyy}-${mm}-${dd}`;

  const { staffGradeData, loading } = useSelector((state) => state.dropdown);
  const { saving } = useSelector((state) => state.save);

  const [formData, setFormData] = useState(prodd);

  const [value, setValue] = useState(prodd?.ssActive ? prodd?.ssActive : "on");

  const onChangeRadio = (checkedValues) => {
    setValue(checkedValues);
  };
  console.log("value",value)

  const onChange = async (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  function onMonthChange(value, formName) { 
    setFormData((prevData) => ({
      ...prevData,
      [formName]: value,
    }));
  }

  console.log("formData", formData?.fyFiscalyear);

  const onFinish = async (data) => {
    const res = await dispatch(
      save({
        fyId: prodd?.fyId ? prodd?.fyId : null,
        fyFiscalyear: formData?.fyFiscalyear,
        fyStartdate: formData?.fyStartdate,
        fyEnddate: formData?.fyEnddate,
        fyActive: value,
        url: "hr/saveFiscYear.action",
      })
    );
    
    if (res?.payload?.success) {
      await toast.success(res?.payload?.messages?.message);
      await handleFetchData();
      await setFormData({});
      await handleCancel();
      await form.resetFields();
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  };

  useEffect(() => {
    setFormData(prodd);
  }, [prodd]);

  useEffect(() => {
    setValue(prodd?.ssActive ? prodd?.ssActive : "on");
  }, [prodd]);

  return (
    <>
      <Modal
        className="modal-btn mod-height mod-footer"
        title={
          prodd
            ? `Edit fiscal year ${prodd?.ptName}`
            : "Add fiscal year details"
        }
        open={open}
        onOk={onFinish}
        onCancel={handleCancel}
        width={850}
      >
        <Form
          layout="vertical"
          ref={formRef}
          name="control-ref"
          onFinish={onFinish}
          className=" "
          style={{
            maxWidth: "100%",
          }}
          form={form}
        >
          <Form.Item
            label="Fiscal Year"
            rules={[
              {
                required: true,
                message: "Fiscal Year required",
              },
            ]}
          >
            <DatePicker
              name="fyFiscalyear"
              className="input"
              picker="year"
              format={"YYYY"}
              placeholder={
                formData?.fyFiscalyear
                  ? moment(formData.fyFiscalyear)?.format("DD-MM-YYYY")
                  : "Select Year"
              }
              value={
                formData?.fyFiscalyear ? dayjs(formData.fyFiscalyear) : null
              }
              onChange={(value) => {
                onMonthChange(value, "fyFiscalyear");
              }}
            />
          </Form.Item>
          <Form.Item
            rules={[
              {
                required: false,
                message: "Field is required",
              },
            ]}
            label="Start Date"
          >
            <DatePicker
              name="fyStartdate" 
              className="input"
              placeholder={
                formData?.fyStartdate
                  ? moment(formData.fyStartdate)?.format("DD-MM-YYYY")
                  : "Select Date"
              }
              value={formData?.fyStartdate ? dayjs(formData.fyStartdate) : null}
              format={"DD-MM-YYYY"}
              onChange={(value) => {
                onMonthChange(value, "fyStartdate");
              }}
            />
          </Form.Item>
          <Form.Item
            rules={[
              {
                required: false,
                message: "Field is required",
              },
            ]}
            label="End Date"
          >
            <DatePicker
              name="fyEnddate" 
              className="input"
              placeholder={
                formData?.fyEnddate
                  ? moment(formData.fyEnddate)?.format("DD-MM-YYYY")
                  : "Select Date"
              }
              value={formData?.fyEnddate ? dayjs(formData.fyEnddate) : null}
              format={"DD-MM-YYYY"}
              onChange={(value) => {
                onMonthChange(value, "fyEnddate");
              }}
            />
          </Form.Item>

          <Form.Item>
          <Checkbox value={"on"} onChange={onChangeRadio}>Active</Checkbox>
          </Form.Item>

          <div className="flex lg:flex-row flex-col justify-between mt-[56px] mb-[48px]">
            <div className="justify-start"></div>
            <div className="justify-end flex items-center gap-x-2">
              <div className="w-[200px]">
                <button
                  key="back"
                  type="button"
                  onClick={handleCancel}
                  className="cstm-btn !bg-white !text-lightBlack !border !border-lightBlack"
                >
                  Cancel
                </button>
              </div>

              <div className="w-[200px]">
                <button
                  key="submit"
                  type="submit"
                  className="cstm-btn"
                  disabled={saving}
                >
                  {saving ? <Spin /> : "Create"}
                </button>
              </div>
            </div>
          </div>
        </Form>
      </Modal>
    </>
  );
};
export default AddFiscalModal;
